/* ============================================================
   LUCERNA MIAMI — modelo de contenido
   El español es el idioma de la casa. El inglés es un interruptor,
   no un cambio de marca.
   ============================================================ */

/* ---------- los diez colores en los que trabajamos ---------- */
/* Sin muestra "todos". El libro se mantiene siempre en un solo color —
   un comerciante le enseña la piedra en el color que pidió, no una hoja
   de contactos. Champaña es el color de la casa, y donde abre. */
window.LUX_COLORS = [
  { key:"white",     en:"White",     es:"Blanco",    hex:"#F2F4F6", grade_en:"D – J",         grade_es:"D – J" },
  { key:"champagne", en:"Champagne", es:"Champaña",  hex:"#C6A664", grade_en:"Fancy Light",   grade_es:"Fancy Light" },
  { key:"yellow",    en:"Yellow",    es:"Amarillo",  hex:"#DFB847", grade_en:"Fancy Vivid",   grade_es:"Fancy Vivid" },
  { key:"pink",      en:"Pink",      es:"Rosa",      hex:"#DF9CA4", grade_en:"Fancy Intense", grade_es:"Fancy Intense" },
  { key:"blue",      en:"Blue",      es:"Azul",      hex:"#6E8EA8", grade_en:"Fancy Deep",    grade_es:"Fancy Deep" },
  { key:"green",     en:"Green",     es:"Verde",     hex:"#94AC8E", grade_en:"Fancy",         grade_es:"Fancy" },
  { key:"orange",    en:"Orange",    es:"Naranja",   hex:"#D7924F", grade_en:"Fancy Vivid",   grade_es:"Fancy Vivid" },
  { key:"purple",    en:"Purple",    es:"Morado",    hex:"#A892B8", grade_en:"Fancy",         grade_es:"Fancy" },
  { key:"gray",      en:"Gray",      es:"Gris",      hex:"#8A939C", grade_en:"Fancy",         grade_es:"Fancy" },
  /* Cognac. A warm brown is its own stone, not a dark champagne — the
     trade calls it cognac and grades it on its own scale. */
  { key:"brown",     en:"Cognac",    es:"Co\u00f1ac",    hex:"#8C6243", grade_en:"Fancy Deep",    grade_es:"Fancy Deep" }
];

/* ---------- lo que montamos, y cómo se asienta la piedra ----------
   `col` es la COLUMNA del precio que corresponde a cada estilo, igual que
   en lucerna-prices.js. `add` es un recargo en dólares enteros para un
   estilo sin columna propia. `band` fija un estilo a una sola fila de
   quilates cuando la pieza no lleva piedra. Los dos idiomas viven en la
   misma fila para que no puedan separarse. El Worker lleva este mismo
   mapa y rechaza cualquier combinación que no esté aquí.
   ---------------------------------------------------------------- */
window.LUX_PIECES = [
  { k:"chain", en:"Chain", es:"Cadena", noStone:true,
    hint_en:"The chain on its own.", hint_es:"Solo la cadena.",
    styles:[
      { k:"cable", en:"Cable", es:"Cable", col:"chain", band:"0.10–0.50" }
    ] },

  { k:"pendant", en:"Pendant", es:"Colgante",
    hint_en:"Set and hung.", hint_es:"Engastado y colgado.",
    styles:[
      { k:"solitaire", en:"Solitaire", es:"Solitario", col:"pendant" },
      { k:"bezel",     en:"Bezel",     es:"Bisel",     col:"pendant-bezel" }
    ] },

  { k:"ring", en:"Ring", es:"Anillo",
    hint_en:"Built to your finger.", hint_es:"Hecho a su medida.",
    styles:[
      { k:"solitaire",       en:"Solitaire",                    es:"Solitario",                         col:"ring" },
      { k:"bezel",           en:"Bezel",                        es:"Bisel",                             col:"ring-bezel" },
      { k:"solitaire-sides", en:"Solitaire with side diamonds", es:"Solitario con diamantes laterales", col:"ring-sides" },
      { k:"bezel-sides",     en:"Bezel with side diamonds",     es:"Bisel con diamantes laterales",     col:"ring-sides", add:110 }
    ] },

  { k:"earrings", en:"Earrings", es:"Aretes",
    hint_en:"Priced as a pair.", hint_es:"Precio por par.",
    styles:[
      { k:"solitaire", en:"Solitaire", es:"Solitario", col:"earrings" },
      { k:"halo",      en:"Halo",      es:"Halo",      col:"earrings-dia" }
    ],
    backs:[
      { k:"push",  en:"Push back",  es:"Cierre de presión" },
      { k:"screw", en:"Screw back", es:"Cierre de rosca" }
    ] }
];

window.LUX_CONTENT = { es: {
  code:"es",
  nav:{ home:"Inicio", book:"El Libro", diamond:"El Diamante", custom:"Hecho a Medida",
        worn:"Llevado", vault:"La Bóveda", journal:"Diario", house:"La Casa",
        careers:"Empleo", contact:"Contacto" },

  heads:{
    book:    { h:"El Libro",       lede:"Treinta y nueve tallas, cada una fotografiada sobre negro. Elija un color y el libro entero cambia." },
    diamond: { h:"El Diamante",    lede:"Mismo carbono. Misma dureza. Mismo certificado. Una historia más corta, y nadie tuvo que excavar para conseguirla." },
    custom:  { h:"Hecho a Medida", lede:"Usted elige la piedra. Nosotros dibujamos la montura, usted aprueba el dibujo, y nuestro taller la construye." },
    worn:    { h:"Llevado",        lede:"En qué se convierten las piedras cuando alguien por fin elige una." },
    vault:   { h:"La Bóveda",      lede:"Piedras sueltas listas para montar — y las piezas terminadas que están entrando en la Vitrina." },
    house:   { h:"La Casa",        lede:"Una bandeja, una lupa y una mesa en Miami." },
    careers: { h:"Empleo",         lede:"Casa pequeña, jornadas largas, piedras de verdad. Si eso le suena a invitación y no a advertencia, mándenos su currículum." },
    journal: { h:"El Diario",      lede:"Cada pieza a medida, contada: la piedra, lo que pidió el cliente, el metal, y lo que salió del taller." },
    contact: { h:"Contacto",       lede:"Escríbanos. Respondemos cada mensaje en 24 horas, en español o en inglés." }
  },

  /* ---------- el configurador de monturas ---------- */
  config:{
    eyebrow:"La montura",
    h:"El precio de la montura.",
    body:"Unas pocas preguntas — cuántas depende de lo que esté montando. El precio aparece mientras responde, y es el precio real: la misma tabla por la que cotizamos por teléfono.",
    q1:"El metal",  q1b:"El platino se cotiza con el 14K.",
    q2:"La pieza",  q2b:"Cadena, colgante, anillo o aretes.",
    q3:"El estilo", q3b:"Cómo se asienta la piedra.",
    q4:"Su piedra central", q4b:"El tamaño del diamante que va dentro.",
    q5:"El cierre", q5b:"Cómo cierra el arete. Ninguno cuesta más.",
    of:"de", from:"desde",
    totalT:"Precio de la montura",
    noStone:"Solo la montura. Este precio no incluye el diamante.",
    noChain:"Solo la cadena. Sin colgante, sin piedra.",
    noChainB:"Nuestra cadena de eslabón cable, hecha en su metal. Añada un colgante arriba y le cotizamos las dos juntas.",
    noStoneB:"Las piedras se compran en cámara durante el vivo, o nos las trae usted. Si todavía no ha elegido ninguna, díganoslo al escribir y le ponemos una bandeja delante.",
    cta:"Continuar al pago",
    ctaQuote:"Solicitar esta montura",
    ctaSub:"Pago seguro",
    pick:"Responda todas y el precio aparece aquí.",
    of3:"de 3",
    madeIn:"Hecho en Miami · de cuatro a seis semanas · fotografiado antes de salir",
    errPick:"Por favor, termine todas las opciones primero.",
    busy:"Abriendo el pago…",
    summaryT:"Su montura",
    included:["Hecha a pedido en su metal","Su piedra engastada por nuestro taller","Fotografiada antes de salir","Envío asegurado y rastreado"],
    reset:"Empezar de nuevo",
    quoteOk:"Su montura está con nosotros.",
    quoteBody:"Tenemos la especificación completa y el precio. Espere respuesta en 24 horas con el dibujo y la forma de pago."
  },

  /* ---------- empleo ---------- */
  careers:{
    eyebrow:"En la mesa",
    h:"Trabajar aquí.",
    body:"No somos una cadena y no somos una startup. Somos unas pocas personas en Miami con una lupa, un banco de trabajo y una cámara, moviendo piedras reales a clientes reales todos los días. Aquí nadie hace un solo trabajo.",
    what:"Qué buscamos",
    points:[
      { t:"Se le puede confiar la bandeja",  b:"Todo en esta casa es pequeño, caro y fácil de perder. Esa es la mayor parte de la entrevista." },
      { t:"Usted contesta",                  b:"Un cliente que escribe a las once de la noche recibe respuesta de una persona, no de un formulario." },
      { t:"No le da reparo el trabajo",      b:"Quien vendió la piedra en cámara también empaca la caja cuando hay que empacarla." },
      { t:"Quiere aprender de piedras",      b:"Talla, color, pureza y quilates se enseñan, y se los enseñamos. La curiosidad no." }
    ],
    rolesT:"Abierto ahora",
    roles:["Presentador de ventas en vivo — español","Presentador de ventas en vivo — inglés",
           "Productor de contenido y redes","Coordinador de logística y operaciones",
           "Auxiliar de envíos","Candidatura abierta"],
    formT:"Envíe su currículum",
    formB:"Díganos qué puesto y una línea sobre por qué. Leemos todas las candidaturas y respondemos en una semana.",
    fName:"Su nombre", fEmail:"Correo electrónico", fPhone:"Teléfono", fRole:"Puesto",
    fLinks:"Portafolio, LinkedIn o Instagram", fLinksHint:"Opcional — un enlace dice más que un párrafo",
    fNote:"Por qué esta casa", fNoteHint:"Unas líneas bastan",
    fFile:"Currículum", fFilePick:"Elegir archivo", fFileChosen:"Adjuntado", fFileHint:"PDF, DOC o DOCX · hasta 8 MB",
    send:"Enviar candidatura", sending:"Enviando…",
    okTitle:"Recibido.", okBody:"Su candidatura está con nosotros. Las leemos todas y respondemos en una semana.",
    errName:"Por favor, añada su nombre.", errEmail:"Por favor, añada un correo al que podamos responder.",
    errResume:"Por favor, adjunte un currículum.", errFile:"Ese archivo pasa de 8 MB. Mándenos uno más pequeño.",
    privacy:"Usamos lo que nos envía únicamente para considerarlo para un puesto aquí. No lo compartimos y no lo añadimos a ninguna lista."
  },

  /* ---------- la vitrina ---------- */
  cabinet:{
    eyebrow:"La vitrina",
    h:"La vitrina.",
    soon:"En tránsito",
    body:"Anillos, aretes y colgantes ya montados y listos para enviar — sin dibujo, sin tiempo de taller, sin espera. El primer envío va camino de Miami. Cuando llegue aparecerá aquí, cada pieza con su certificado y su precio en la página.",
    cta:"Ver el vivo", ctaSub:"@lucernadiamonds",
    alt:"Hacer una a su medida"
  },

  /* ---------- el diario ---------- */
  journal:{loading:"Cargando\u2026", back:"Todas las piezas", 
    eyebrow:"El diario",
    h:"Piezas terminadas.",
    body:"Cada pieza que sale de este taller se cuenta por escrito: la piedra que eligió el cliente, lo que pidió, el metal, y una fotografía de la cosa terminada. Es lo más cerca que podemos estar de pasarle la bandeja por internet.",
    soon:"Se están escribiendo las primeras entradas",
    empty:"Todavía no hay nada publicado. Los primeros encargos de la temporada se están fotografiando ahora.",
    cta:"Diseñar su pieza",
    readMore:"Leer"
  },

  hero:{
    eyebrow:"Miami · Certificado IGI",
    l1:"Bajo", l2:"cualquier", l3:"luz.",
    sub:"Diamantes sueltos cultivados en laboratorio. Treinta y nueve tallas, diez colores, cada piedra certificada por IGI y grabada con láser. Tres mil millones de años, o cincuenta días: la piedra no nota la diferencia, y el laboratorio que la gradúa tampoco.",
    cta1:"Diseñar su pieza", cta2:"Ver las tallas"
  },

  badges:[
    { k:"IGI", t:"Certificado IGI",        s:"Cada piedra, sin excepción" },
    { k:"39",  t:"Tallas en el libro",     s:"Treinta y nueve, y subiendo" },
    { k:"9",   t:"Colores fancy",          s:"Blanco, amarillo, rosa, azul" },
    { k:"MIA", t:"En vivo desde Miami",    s:"En español, todas las noches" }
  ],

  ticker:"Bajo cualquier luz · Certificado IGI · Cultivado en laboratorio · Color fancy · Grabado con láser · Hecho a medida · Miami, Florida · ",

  showcase:{
    eyebrow:"La bandeja",
    h:"Lo que tenemos.",
    body:"Treinta y nueve tallas, de un brillante redondo a una cometa, una media luna o una estrella. Cada una se trabaja en los diez colores. Elija una forma y la vemos juntos en el vivo.",
    cta:"Ver las treinta y nueve"
  },

  selection:{
    eyebrow:"La selección",
    h:"Toda la bandeja.",
    body:"Esto es lo que nos separa: casi cualquier casa le vende un redondo blanco. Nosotros trabajamos en pentágono, cometa, marquesa holandesa, oval escalonado — y los trabajamos en color. Elija un color, elija una forma, y la bandeja entera cambia.",
    fColor:"Color", fShape:"Forma",
    shapeAll:"Todas", shapeRound:"Redonda", shapeOval:"Oval", shapePear:"Pera y corazón",
    shapeMarquise:"Marquesa", shapeSquare:"Cuadrada y rectangular", shapeGeometric:"Geométrica", shapeSide:"Media y lateral",
    house:"Forma de la casa", facets:"facetas", count:"tallas mostradas",
    none:"Ninguna talla coincide con esa combinación. Quite un filtro, o escríbanos y la buscamos.",
    note:"La disponibilidad cambia cada semana. Si busca una talla concreta en un color concreto, escríbanos y la buscamos."
  },

  upclose:{
    eyebrow:"De cerca",
    h:"Un color,<br>dos tallas.",
    body:"El mismo azul se lee distinto según cómo esté facetada la piedra. Un brillante rompe el color en destellos y lo dispersa; una talla alargada lo sostiene en planos más largos y más tranquilos. Ninguna es mejor. Son dos argumentos distintos para el mismo tono — y por eso vale la pena mirar de cerca antes de decidir.",
    lede:"Un rosa intenso salido de la tierra se vende en Ginebra. Salido de un laboratorio, se puede tener.",
    drag:"Arrastre para comparar",
    left:"Brillante · redondo", right:"Brillante · marquesa holandesa"
  },

  stone:{
    eyebrow:"El diamante",
    h:"Hecho a propósito.",
    lede:"Mismo carbono. Misma dureza. Mismo fuego. La única diferencia es la biografía.",
    body:"Un diamante cultivado en laboratorio cristaliza en semanas dentro de una cámara en lugar de a lo largo de mil millones de años bajo tierra. Estructura idéntica, propiedades ópticas idénticas, la misma respuesta a la luz. Un gemólogo necesita equipo para distinguirlos; a simple vista, nadie puede.\n\nSe crean de dos maneras: HPHT, que reproduce la presión y el calor del manto terrestre, y CVD, que deposita carbono capa por capa sobre una semilla. Su informe IGI dice cuál se usó.",
    colLab:"Laboratorio", colMine:"Mina",
    rows:[
      ["Composición","Carbono","Carbono"],
      ["Dureza","10 / 10","10 / 10"],
      ["Brillo y fuego","Idénticos","Idénticos"],
      ["Procedencia","Sabemos el día exacto","Es una larga historia"],
      ["Conflicto","Cero sangre. Solo carbono.","Depende de a quién le pregunte"],
      ["Color intenso","Rosa, azul, verde — de verdad alcanzables","Precios de subasta internacional"],
      ["Tallas raras","Cometa, pentágono, cadillac — sin drama","Pedido especial y paciencia"],
      ["Por el mismo presupuesto","Más quilates, mejor color, mejor pureza","Menos de todo"],
      ["Tiempo de espera","Unas semanas","≈ 1.000.000.000 de años"]
    ],
    candor:"Una nota de franqueza: una piedra cultivada en laboratorio no es un instrumento de inversión. El valor de reventa es modesto. Se compra porque es bonita."
  },

  vocab:{
    eyebrow:"Vocabulario",
    h:"Quilates, color,<br>pureza, talla.",
    items:[
      { t:"Quilates", b:"Peso, no tamaño. Un quilate son 0,20 gramos. Dos piedras del mismo peso pueden verse distintas de frente: una talla profunda esconde su peso hacia abajo." },
      { t:"Color",    b:"Los blancos van de la D, incoloro, a la Z. Las piedras de color usan otra escala: Fancy Light, Fancy, Fancy Intense, Fancy Vivid, Fancy Deep. Ahí es donde vivimos." },
      { t:"Pureza",   b:"De FL e IF, impecables, bajando por VVS, VS, SI hasta I. El informe incluye un mapa que muestra dónde está cada marca interna." },
      { t:"Talla",    b:"La única de las cuatro hecha por una mano humana. Gobierna el brillo — y, en una piedra de color, cuánto color se ve." }
    ]
  },

  cert:{
    eyebrow:"Certificación",
    h:"El papel.",
    body:"El Instituto Gemológico Internacional es uno de los laboratorios de referencia del mundo para piedras cultivadas. Cada una de las nuestras llega con el suyo. Vale la pena saber leer uno — y no solo el nuestro, el de cualquiera.",
    lines:[
      ["Report Number","El número único del informe. Sirve para verificar la piedra en igi.org."],
      ["Laboratory Grown","Esta línea tiene que aparecer siempre. Sin ella, no es un informe de piedra cultivada."],
      ["Growth Method","HPHT o CVD. Cómo se formó la piedra."],
      ["Shape and Cutting Style","La talla por su nombre técnico — desde redondo brillante hasta cometa, pentágono o marquesa holandesa."],
      ["Color Grade","En una piedra de color, la descripción fancy completa: intensidad, tono y saturación. Es la línea que leemos con más cuidado."],
      ["Carat Weight","Peso exacto, normalmente con dos decimales."],
      ["Measurements","Milímetros. Esto es lo que de verdad le dice el tamaño de frente."],
      ["Clarity Grade","De FL a I3, acompañado del mapa de pureza."],
      ["Cut · Polish · Symmetry","Calidad de talla, pulido y simetría. El grado de talla solo aplica a los redondos."],
      ["Fluorescence","Su reacción bajo luz ultravioleta. None, Faint, Medium, Strong."],
      ["Laser Inscription","Muchas piedras llevan el número grabado en el cinturón. Se lee con una lupa de 10×."],
      ["Comments","Notas del laboratorio. Siempre vale la pena leerlas."]
    ],
    habit:"En igi.org, en Report Check, se escribe el número y aparece el informe. Se puede hacer durante el vivo, antes de decidir. Nos parece la costumbre más sana del oficio."
  },

  record:{
    eyebrow:"La casa",
    h:"Lucerna Miami.",
    body:"Lucerna es el tragaluz: la abertura que se abre en un techo para dejar entrar la luz del día. Le pusimos ese nombre a una casa que vende el único objeto del mundo que existe para hacer exactamente lo mismo. La piedra se enseña antes de venderse, el papel está en pantalla antes de la puja, y la talla rara que lleva buscando probablemente ya está en la bandeja.",
    title:"Ficha de la piedra", tag:"Ejemplo",
    rows:[
      ["Tipo","Diamante cultivado en laboratorio"],
      ["Método","CVD"],
      ["Talla","Cometa"],
      ["Peso","1,28 ct"],
      ["Color","Fancy Intense Pink"],
      ["Pureza","VS1"],
      ["Pulido / Simetría","Excellent / Excellent"],
      ["Medidas","9,14 × 6,02 × 3,41 mm"],
      ["Fluorescencia","None"],
      ["Informe","IGI · LG······"]
    ],
    note:"Ficha de ejemplo — así se presenta cada piedra en el vivo."
  },

  days:{
    eyebrow:"La fabricación",
    h:"Cincuenta días.",
    body:"La gente da por hecho que un diamante cultivado es rápido. No lo es. Es paciente en otro sitio — y durante la mayoría de esas semanas hay una persona vigilándolo. Una oblea de diamante semilla se queda en un plasma de metano e hidrógeno a entre 900 y 1.200 °C mientras el carbono se posa sobre ella capa atómica a capa atómica. Cada pocos días la placa sale, se vuelve a pulir a mano, y entra otra vez.",
    caption:"Una forma fancy de tres quilates, etapa por etapa",
    colStage:"Etapa", colDays:"Días",
    stages:[
      ["Preparación de la semilla y carga del reactor","1"],
      ["Crecimiento en el reactor","21–28"],
      ["Separación, mapeo y marcado","3"],
      ["Aserrado, bruting y bloqueo","3"],
      ["Brillanteado y pulido final","4–6"],
      ["Certificación IGI","15"]
    ],
    total:"De la semilla al certificado", totalV:"47–56",
    barTitle:"A dónde se van los días — 49,5 días, lo habitual",
    keyGrowth:"Crecimiento", keyCutting:"Tallado", keyIgi:"IGI",
    hoursLabel:"Horas de atención humana cualificada",
    hoursBody:"Unas 80 de ellas son las manos de un tallador sobre un disco de hierro fundido cargado con polvo de diamante. Nada sale de aquí sin certificar — cada piedra va al IGI, y no recortamos esos quince días.",
    pull:"No está pagando por escasez.", pull2:"Está pagando por los días."
  },

  bespoke:{
    eyebrow:"Hecho a medida",
    h:"A su medida.",
    body:"Mándenos un boceto en el reverso de un sobre, una captura de pantalla, o la foto de algo que vio en un escaparate. Se lo construimos. No hay catálogo del que elegir, porque no hay catálogo. Cada pieza de Lucerna Miami se hace una vez, para una persona, por joyeros de banco que se criaron en el oficio.",
    offers:[
      ["Cualquier diseño. Cualquier piedra.","Solitario, tres piedras, halo, bisel, toi-et-moi, o algo que nadie ha hecho todavía."],
      ["Oro macizo.","Amarillo, blanco o rosa — macizo de lado a lado. Nunca chapado, nunca relleno, nunca hueco."],
      ["Terminado a mano en el banco.","Asientos cortados bajo aumento, galerías terminadas por dentro, donde solo usted las verá."],
      ["Su piedra, o la nuestra.","Montamos con gusto un diamante que ya tenga, heredado o comprado en otro sitio."]
    ],
    specLabels:["Dise\u00f1o","Metal","Acabado","La piedra"],
    chainTitle:"Seis pasos, de principio a fin",
    chainHint:"Seleccione un paso",
    chain:[
      { t:"Hablar", b:"Una conversación, no un formulario. Para qué es la pieza, quién la lleva, qué tiene ya, qué prefiere evitar. Diez minutos aquí ahorran tres semanas después." },
      { t:"Boceto", b:"Un dibujo a mano, enviado la misma semana. Proporciones, el asiento de la piedra, el ancho del hombro. Cambie lo que quiera. No se compromete nada hasta que le guste el dibujo." },
      { t:"CAD", b:"El boceto se convierte en un modelo 3D preciso, renderizado desde los ángulos que de verdad va a ver. Aquí es donde se deciden los milímetros — ancho de aro, altura de galería, cuánto sobresale la piedra." },
      { t:"Cera", b:"El modelo se imprime y se funde. Un objeto físico que podría sostener, si estuviera en la sala. Lo fotografiamos contra una mano para dar escala antes de verter nada en oro." },
      { t:"Banco", b:"Un joyero corta los asientos bajo aumento, engasta la piedra y termina la galería por dentro — la parte que solo ve quien la lleva. Esta es la parte lenta, y debe serlo." },
      { t:"Revisión", b:"Inspección final a 10 aumentos y bajo dos condiciones de luz. Aquí vuelven al banco más piezas de las que la mayoría de las casas toleraría. Después se encaja, se asegura y se envía." }
    ]
  },

  commission:{
    eyebrow:"Personalización",
    h:"Cuéntenos la pieza.",
    body:"Mándenos los detalles y una imagen de lo que quiere — una captura, un boceto, la foto de un escaparate. Nuestro equipo revisa cada solicitud a mano y vuelve con una cotización.",
    fName:"Nombre completo", fEmail:"Correo electrónico", fPhone:"Teléfono o WhatsApp",
    fTikTok:"Usuario de TikTok", fTikTokHint:"Si compró en nuestro vivo",
    fStone:"Qué diamante", fStoneHint:"Talla, color, quilates, o el número del informe IGI",
    fPiece:"Qué le gustaría que hiciéramos", fPieceOpts:["Anillo","Colgante","Aretes","Pulsera","Todavía no lo sé","Otra cosa"],
    fDetails:"Cuéntenos sobre la pieza",
    fDetailsHint:"Color del metal, talla de dedo, ocasión, rango de presupuesto — lo que ayude",
    fFile:"Adjuntar una imagen", fFileHint:"Una captura, un boceto o una foto. Opcional, pero ayuda.",
    fFileChosen:"Adjuntado",
    submit:"Enviar solicitud", sending:"Enviando…",
    required:"Por favor, complete su nombre, su correo y qué le gustaría que hiciéramos.",
    okTitle:"Gracias.",
    okBody:"Nuestro equipo se pondrá en contacto en las próximas 24 horas con una cotización.",
    okNote:"Se ha enviado una copia a info@lucernamiami.com.",
    mailNote:"Se ha abierto su programa de correo con todo rellenado. Adjunte su imagen y pulse enviar.",
    close:"Cerrar",
    quoted:"Cada pieza a medida se cotiza individualmente. El precio de la montura depende del diseño, del metal y de la piedra que se vaya a engastar."
  },

  live:{
    eyebrow:"En cámara",
    h:"La bandeja, en cámara.",
    body:"Vendemos la piedra suelta. Lo que haga con ella después — un solitario, un colgante, un anillo de aniversario, un regalo que no se parece al de nadie — es la parte divertida.",
    soon:"En vivo, casi todas las noches",
    soonBody:"La bandeja sale en cámara en TikTok. Las piedras se muestran de una en una — certificado, medidas, color bajo dos luces — y se venden en la sala.",
    cta:"Ver en TikTok", ctaSub:"@lucernadiamonds"
  },

  wornband:{
    eyebrow:"Llevado",
    h:"Después de la bandeja.",
    body:"Vendemos la piedra suelta. En qué se convierte, y en qué mano termina, es la parte que nos gusta mirar.",
    cta:"Verlas llevadas"
  },

  worn:{
    eyebrow:"Llevado",
    h:"En la mano.",
    body:"Cada pieza de aquí empezó como una piedra suelta sobre una bandeja de terciopelo, elegida por alguien que sabía exactamente cuál quería. Después nuestro taller la engastó.",
    note:"Hecho a medida. No hay dos iguales. Díganos qué tiene en mente y se lo dibujamos primero.",
    cta:"Diseñar su pieza"
  },

  pages:{
    eyebrow:"La casa",
    h:"La casa, por dentro.",
    items:[
      { k:"book",    t:"El Libro",       s:"Treinta y nueve tallas",      b:"Cometa, marquesa holandesa, mina antigua, estrella. Filtre por color y por forma.", img:"trade-01-tweezers",  href:"#selection" },
      { k:"vault",   t:"La Bóveda",      s:"Lo que hay en la bandeja",    b:"Piedras con sus quilates, su color y su número IGI.",                               img:"trade-04-desk",      href:"#vault" },
      { k:"diamond", t:"El Diamante",    s:"Mismo carbono, historia más corta", b:"Cincuenta días de la semilla al certificado, explicados sin el discurso de venta.", img:"stone-hero",   href:"#stone" },
      { k:"order",   t:"Hecho a Medida", s:"Construya la pieza",          b:"Seis pasos de una conversación a un anillo terminado.",                             img:"ring-05-backlit",    href:"#bespoke" },
      { k:"journal", t:"El Diario",     s:"Cada encargo",               b:"La piedra, lo que se pidi\u00f3, el metal, y lo que sali\u00f3 del taller.",           img:"trade-04-desk",     href:"#journal" },
      { k:"house",   t:"La Casa",        s:"Dónde compra la tienda",      b:"Una bandeja, una lupa y una mesa en Miami.",                                        img:"trade-05-handover",  href:"#ethics" }
    ]
  },

  vault:{
    eyebrow:"La bóveda",
    h:"Lo que hay hoy.",
    soon:"Por ahora se venden en vivo",
    body:"La bóveda en línea se está construyendo. Hasta que abra, todo lo que tenemos se muestra en TikTok — cada piedra con su número de informe IGI, sus medidas y su color bajo dos luces. Si busca una talla o un color concretos, díganoslo y lo buscamos.",
    cta:"Ver qué hay en la bandeja", ctaSub:"@lucernadiamonds",
    alt:"Pedir una piedra concreta"
  },

  ethics:{
    eyebrow:"Por qué importa",
    h:"De dónde viene.",
    body:"Cada quilate extraído carga con una historia que usted no puede ver. Un diamante cultivado carga con una que se puede leer — ningún pozo abierto, ningún cauce desviado, ningún yacimiento desplazado, ninguna balsa de residuos dejada para que la gestione el siglo siguiente.",
    items:[
      ["Sin conflicto. Nunca.","Cultivado en un reactor sellado bajo un solo techo. Sin mina, sin milicia, sin una cadena de custodia que haya que creerse."],
      ["Sin tierra removida.","Sin pozo, sin estériles, sin balsas, sin una deuda de rehabilitación dejada a una comunidad."],
      ["El agua se queda donde está.","Ningún río desviado, ningún limo, ninguna lechada de procesado que decantar después."],
      ["Una huella que puede mejorar.","La energía es la única entrada real, y la energía se puede producir limpia. Una mina no se puede des-excavar."]
    ],
  },

  films:{
    hero:"Una piedra, girando despacio, bajo una sola luz.",
    girdle:"Todo lo que se dice de un diamante es una medida. Aquí está la piedra que describen esas medidas.",
    ring:"Primero se elige la piedra. Todo lo demás se construye a su medida.",
    tray:"Lo que hay en la bandeja esta semana, y lo que ya tiene dueño.",
    wax:"Empieza en cera, tallada a mano, hecha para su piedra y para ninguna otra.",
    bench:"Se abre el asiento para el filetín. Una décima de milímetro decide si sujeta.",
    setting:"La piedra baja una sola vez. No hay segundo intento que no se note.",
    final:"Después se pule, y ya es suya.",
  },
  forms:{
    linkHint:"Pegue un enlace \u2014 Drive, Dropbox, iCloud",
    posted:"Gracias \u2014 su mensaje ya est\u00e1 en la casa. Respondemos cada uno en 24 horas.",
  },
  journalEntries:[],
  faq:{
    eyebrow:"Preguntas",
    h:"Preguntas.",
    items:[
      ["¿Un diamante de laboratorio es un diamante de verdad?",
       "Sí. La misma red de carbono, el mismo 10 en la escala de Mohs, el mismo brillo y el mismo fuego. No es moissanita ni circonita — esos son materiales distintos que imitan al diamante. Un diamante de laboratorio ES diamante; la única diferencia es dónde cristalizó."],
      ["¿Alguien va a poder notarlo?",
       "A simple vista no, y con lupa tampoco. Un gemólogo necesita equipo especializado. Su informe IGI dice con todas sus letras que la piedra es cultivada en laboratorio, y muchas piedras llevan el número del informe grabado en el cinturón."],
      ["¿Qué garantiza realmente un certificado IGI?",
       "Registra lo que midió el laboratorio: método de crecimiento, forma, quilates, grado de color, pureza, medidas, pulido, simetría y fluorescencia. Usted mismo puede verificar cualquier informe en igi.org, en Report Check, con el número — durante el vivo, antes de decidir."],
      ["¿Venden joyería terminada?",
       "Vendemos la piedra suelta. Las monturas se hacen a medida en el banco — anillo, colgante, aretes o pulsera — y montamos con gusto un diamante que usted ya tenga. Empiece por el formulario de piezas a medida de esta página."],
      ["¿Cuánto cuesta una montura?",
       "El configurador de esta página le da el precio real de la montura al instante, de la misma tabla por la que cotizamos por teléfono. Un diseño que se salga de la tabla se cotiza individualmente, y el equipo responde en 24 horas."],
      ["¿Cuánto tarda una pieza a medida?",
       "Hablar, boceto, CAD, cera, banco, revisión. Normalmente de tres a cinco semanas desde el CAD aprobado, según el diseño y según si la piedra ya está en la bandeja o todavía está creciendo."],
      ["¿Es un diamante de laboratorio una buena inversión?",
       "No, y preferimos decirlo. El valor de reventa es modesto y los precios de la categoría llevan años bajando. Cómprelo porque es bonito y porque es el color y la talla que quería — no como un activo."],
      ["¿Y si la piedra llega dañada o distinta a lo descrito?",
       "Se arregla sin discusión. Lo que aparece en pantalla es lo que llega en la caja; ese es todo el sentido de enseñar el certificado primero."],
      ["¿Envían fuera de Estados Unidos?",
       "Sí, asegurado y rastreado. Los aranceles e impuestos de importación corren por cuenta del comprador y varían según el país — escríbanos antes de pujar y le decimos qué esperar."],
      ["¿Puedo pedir una talla que no tengan?",
       "A menudo sí. La disponibilidad cambia cada semana y podemos encargar una forma. Díganos la talla, el color y los quilates que tiene en mente y le decimos con honestidad si es realista."],
      ["¿Hablan inglés?",
       "Yes. El vivo, la página y el papeleo están todos disponibles en inglés."],
      ["¿Cómo hablo con una persona de verdad?",
       "Pídale a Lucía un representante y ella toma sus datos, o escriba a info@lucernamiami.com. Nuestro equipo responde en 24 horas, todos los días."]
    ]
  },

  contact:{
    eyebrow:"Contacto",
    h:"Hablemos.",
    email:"Correo", tiktok:"TikTok", hours:"Horario", hoursV:"Todos los días",
    replies:"Respuestas", repliesV:"En 24 horas",
    cityLine:"Lucerna Miami · Miami, Florida",
    blurb:"Diamantes cultivados en laboratorio en tallas raras y colores raros. Cada piedra certificada por IGI, cada montura hecha a medida, cada pieza hecha una sola vez.",
    formT:"O escríbanos aquí",
    fName:"Nombre", fEmail:"Correo electrónico", fPhone:"Teléfono o WhatsApp (opcional)",
    fTopic:"Sobre qué", fTopicOpts:["Una piedra en concreto","Avisos del próximo vivo","Montar una piedra que ya tengo","Una montura a medida","Al por mayor","Otra cosa"],
    fMsg:"Su mensaje", send:"Enviar", sending:"Enviando…",
    ok:"Recibido. Le respondemos en 24 horas.",
    err:"Necesitamos un nombre y un correo válido."
  },

  legal:{
    terms:"Términos y Condiciones", privacy:"Política de Privacidad", shipping:"Envíos y Devoluciones",
    back:"Volver a la casa", updated:"Última actualización",
    disclaimer:"Todos los diamantes que vende Lucerna Miami son cultivados en laboratorio y van acompañados de un informe IGI. Los diamantes cultivados en laboratorio son química, física y ópticamente idénticos a los extraídos de mina. Los precios se expresan en dólares estadounidenses; las piedras y las monturas se cotizan por separado e individualmente. El color en pantalla varía según el dispositivo — el informe IGI es la descripción definitiva de cualquier piedra. Los diamantes cultivados en laboratorio no se venden como inversión y su valor de reventa es modesto. La disponibilidad cambia cada semana."
  },

  footer:{ rights:"Todos los derechos reservados", line:"Cultivado en laboratorio · Certificado IGI · Hecho a medida",
           tagline:"Bajo cualquier luz." },

  bot:{
    title:"Lucía", role:"Concierge de la casa",
    hello:"Buenas noches — soy Lucía, de la casa.\n\nPregúnteme por una forma, un color, qué le compran de verdad cincuenta días en el reactor, o cuánto costaría montar una piedra que ya tiene. Si prefiere hablar con alguien del equipo, dígamelo y ya está.",
    chips:["¿Qué es una marquesa holandesa?","¿Laboratorio o mina?","Montar una piedra que ya tengo","Hablar con un representante"],
    ph:"Pregunte por una piedra, una forma, un precio…",
    offline:"Escriba a info@lucernamiami.com",
    noReach:"No consigo alcanzar la línea de la casa desde aquí. Escriba a info@lucernamiami.com y el equipo responde en 24 horas.",
    notGranted:"Necesitaría su permiso para responder desde aquí. info@lucernamiami.com llega directamente al taller.",
    rateLimited:"Un momento — demasiadas preguntas a la vez. Pruébeme otra vez en un rato.",
    generic:"Algo falló de mi lado. info@lucernamiami.com llega directamente al taller.",
    connecting:"Conectando…",
    leadOk:"Gracias — he pasado sus datos al equipo. Alguien se pondrá en contacto en las próximas 24 horas.",
    offerForm:"Esa prefiero no contestarla de memoria. Mándenosla y tendrá una respuesta en 24 horas.",
    openForm:"Abrir el formulario de piezas a medida"
  },

  seo:{
    title:"Lucerna Miami — Diamantes de Laboratorio Certificados IGI",
    desc:"Treinta y nueve tallas de diamante en diez colores fancy, cada piedra certificada por IGI y grabada con láser. Cometa, pentágono, marquesa holandesa y oval escalonado, hechos a medida en Miami."
  }
}};

/* ============================================================
   LUCERNA MIAMI — content model, English.
   The pivot is a switch, not a rebrand. US English spelling.
   ============================================================ */
window.LUX_CONTENT.en = {
  code:"en",
  nav:{ home:"Home", book:"The Book", diamond:"The Diamond", custom:"Made to Order",
        worn:"Worn", vault:"The Vault", journal:"Journal", house:"The House",
        careers:"Careers", contact:"Contact" },

  heads:{
    book:    { h:"The Book",      lede:"Thirty-nine cuts, every one photographed on black. Choose a color and the whole book turns." },
    diamond: { h:"The Diamond",   lede:"Same carbon. Same hardness. Same certificate. A shorter story, and nobody had to dig for it." },
    custom:  { h:"Made to Order", lede:"You choose the stone. We draw the setting, you approve the drawing, and our bench builds it." },
    worn:    { h:"Worn",          lede:"What the stones become once somebody finally chooses one." },
    vault:   { h:"The Vault",     lede:"Loose stones ready to set — and the finished pieces coming into The Cabinet." },
    house:   { h:"The House",     lede:"A tray, a loupe, and a table in Miami." },
    careers: { h:"Careers",       lede:"Small house, long hours, real stones. If that reads as an invitation rather than a warning, send us your resume." },
    journal: { h:"The Journal",   lede:"Every made-to-order piece, written up: the stone, the brief, the metal, and what came off the bench." },
    contact: { h:"Contact",       lede:"Write to us. Every message is answered within 24 hours, in Spanish or English." }
  },

  config:{
    eyebrow:"The setting",
    h:"What the setting costs.",
    body:"A few questions — how many depends on what you are making. The price appears as you answer them, and it is the real price: the same chart we quote from on the phone.",
    q1:"The metal",  q1b:"Platinum is priced with 14K.",
    q2:"The piece",  q2b:"Chain, pendant, ring or earrings.",
    q3:"The style",  q3b:"How the stone sits in it.",
    q4:"Your center stone", q4b:"The size of the diamond going into it.",
    q5:"The back",   q5b:"How the earring closes. Neither costs more.",
    of:"of", from:"from",
    totalT:"Setting price",
    noStone:"Setting only. This price does not include a diamond.",
    noChain:"The chain only. No pendant, no stone.",
    noChainB:"Our cable chain, made in your metal. Add a pendant above and we will price the two together.",
    noStoneB:"Stones are bought on camera during our live, or brought to us. If you have not chosen one yet, say so when you write and we will put a tray in front of you.",
    cta:"Continue to checkout",
    ctaQuote:"Request this setting",
    ctaSub:"Secure checkout",
    pick:"Answer them all and the price appears here.",
    of3:"of 3",
    madeIn:"Made in Miami · four to six weeks · photographed before it ships",
    errPick:"Please finish every choice first.",
    busy:"Opening checkout…",
    summaryT:"Your setting",
    included:["Built to order in your metal","Your stone set by our bench","Photographed before it ships","Insured shipping, fully tracked"],
    reset:"Start again",
    quoteOk:"Your setting is with us.",
    quoteBody:"We have the full specification and the price. Expect a reply within 24 hours with the drawing and how to pay."
  },

  careers:{
    eyebrow:"At the table",
    h:"Working here.",
    body:"We are not a chain and we are not a start-up. We are a few people in Miami with a loupe, a bench and a camera, moving real stones to real customers every day. Nobody here does only one job.",
    what:"What we look for",
    points:[
      { t:"You can be trusted with the tray",    b:"Everything in this house is small, expensive and easy to lose. That is most of the interview." },
      { t:"You answer people",                   b:"A customer who writes at eleven at night gets an answer from a person, not a form." },
      { t:"You are not precious about the work", b:"Whoever sold the stone on camera also packs the box when the box needs packing." },
      { t:"You want to learn stones",            b:"Cut, color, clarity and carat can be taught, and we will teach them. Curiosity cannot." }
    ],
    rolesT:"Open now",
    roles:["Live Sales Host — Spanish","Live Sales Host — English",
           "Social Media & Content Producer","Logistics & Operations Coordinator",
           "Shipping & Fulfillment Associate","Open Application"],
    formT:"Send your resume",
    formB:"Tell us which role and one line about why. We read every application and reply within a week.",
    fName:"Your name", fEmail:"Email", fPhone:"Phone", fRole:"Role",
    fLinks:"Portfolio, LinkedIn or Instagram", fLinksHint:"Optional — a link tells us more than a paragraph",
    fNote:"Why this house", fNoteHint:"A few lines is plenty",
    fFile:"Resume", fFilePick:"Choose a file", fFileChosen:"Attached", fFileHint:"PDF, DOC or DOCX · up to 8 MB",
    send:"Send application", sending:"Sending…",
    okTitle:"Received.", okBody:"Your application is with us. We read every one and reply within a week.",
    errName:"Please add your name.", errEmail:"Please add an email we can reply to.",
    errResume:"Please attach a resume.", errFile:"That file is over 8 MB. Please send a smaller one.",
    privacy:"We use what you send only to consider you for work here. We do not share it, and we do not add you to a list."
  },

  cabinet:{
    eyebrow:"The cabinet",
    h:"The cabinet.",
    soon:"In transit",
    body:"Rings, studs and pendants already set and ready to ship — no drawing, no bench time, no wait. The first shipment is on its way to Miami. When it lands it goes here, each piece with its certificate and its price on the page.",
    cta:"Watch the live", ctaSub:"@lucernadiamonds",
    alt:"Have one made instead"
  },

  journal:{loading:"Loading\u2026", back:"All pieces", 
    eyebrow:"The journal",
    h:"Finished pieces.",
    body:"Every custom piece that leaves this bench gets written up: the stone the customer chose, what they asked for, the metal, and a photograph of the finished thing. It is the closest we can get to handing you the tray over the internet.",
    soon:"First entries being written",
    empty:"Nothing published yet. The first pieces of the season are being photographed now.",
    cta:"Design your piece",
    readMore:"Read"
  },

  hero:{
    eyebrow:"Miami · IGI certified",
    l1:"Under", l2:"any", l3:"light.",
    sub:"Loose laboratory-grown diamonds. Thirty-nine cuts, ten colors, every stone IGI certified and laser inscribed. Three billion years, or fifty days: the stone cannot tell the difference, and neither can the laboratory that grades it.",
    cta1:"Design your piece", cta2:"See the cuts"
  },

  badges:[
    { k:"IGI", t:"IGI certified",        s:"Every stone, no exceptions" },
    { k:"39",  t:"Cuts in the book",     s:"Thirty-nine, and counting" },
    { k:"9",   t:"Fancy colors",          s:"White, yellow, pink, blue" },
    { k:"MIA", t:"Live from Miami",      s:"In Spanish, every night" }
  ],

  ticker:"Under any light · IGI certified · Laboratory grown · Fancy color · Laser inscribed · Made to order · Miami, Florida · ",

  showcase:{
    eyebrow:"The tray",
    h:"What we carry.",
    body:"Thirty-nine cuts, from a round brilliant to a kite, a half moon or a star. Every one of them worked in the ten colors. Pick a shape and we will look at it together on the live.",
    cta:"See all thirty-nine"
  },

  selection:{
    eyebrow:"The selection",
    h:"The whole tray.",
    body:"This is what sets us apart: almost any house will sell you a white round. We work in pentagon, kite, Dutch marquise, oval step — and we work them in color. Choose a color, choose a shape, and the whole tray changes.",
    fColor:"Color", fShape:"Shape",
    shapeAll:"All", shapeRound:"Round", shapeOval:"Oval", shapePear:"Pear & heart",
    shapeMarquise:"Marquise", shapeSquare:"Square & rectangle", shapeGeometric:"Geometric", shapeSide:"Half & side",
    house:"House shape", facets:"facets", count:"cuts shown",
    none:"No cut matches that combination. Clear a filter, or write to us and we will look for it.",
    note:"Availability changes weekly. If you are after a particular cut in a particular color, write to us and we will look for it."
  },

  upclose:{
    eyebrow:"Up close",
    h:"One color,<br>two cuts.",
    body:"The same blue reads differently depending on how the stone is faceted. A brilliant breaks the color into flashes and scatters it; an elongated cut holds it in longer, calmer planes. Neither is better. They are different arguments for the same hue — which is why it is worth a close look before deciding.",
    lede:"An intense pink out of the ground sells in Geneva. Out of a laboratory, it can be owned.",
    drag:"Drag to compare",
    left:"Brilliant · round", right:"Brilliant · Dutch marquise"
  },

  stone:{
    eyebrow:"The diamond",
    h:"Made on purpose.",
    lede:"Same carbon. Same hardness. Same fire. The only difference is the biography.",
    body:"A laboratory-grown diamond crystallizes in weeks inside a chamber rather than over a billion years underground. Identical structure, identical optical properties, the same answer to light. A gemologist needs equipment to tell; by eye, no one can.\n\nThey are created two ways: HPHT, which reproduces the pressure and heat of the earth's mantle, and CVD, which deposits carbon layer by layer onto a seed. Your IGI report states which was used.",
    colLab:"Laboratory", colMine:"Mine",
    rows:[
      ["Composition","Carbon","Carbon"],
      ["Hardness","10 / 10","10 / 10"],
      ["Brilliance and fire","Identical","Identical"],
      ["Provenance","We know the exact day","It's a long story"],
      ["Conflict","Zero blood. Just carbon.","Depends who you ask"],
      ["Intense color","Pink, blue, green — genuinely attainable","International auction prices"],
      ["Rare cuts","Kite, pentagon, cadillac — no drama","Special order and patience"],
      ["For the same budget","More carat, better color, better clarity","Less of everything"],
      ["Wait time","A few weeks","≈ 1,000,000,000 years"]
    ],
    candor:"A note of candor: a laboratory-grown stone is not an investment instrument. Resale value is modest. You buy it because it is beautiful."
  },

  vocab:{
    eyebrow:"Vocabulary",
    h:"Carat, color,<br>clarity, cut.",
    items:[
      { t:"Carat",   b:"Weight, not size. One carat is 0.20 grams. Two stones of equal weight can look different face-up: a deep cut hides its weight downward." },
      { t:"Color",   b:"Whites run D, colorless, to Z. Colored stones use another scale: Fancy Light, Fancy, Fancy Intense, Fancy Vivid, Fancy Deep. That is where we live." },
      { t:"Clarity", b:"From FL and IF, flawless, down through VVS, VS, SI to I. The report includes a plot showing where each internal mark sits." },
      { t:"Cut",     b:"The only one of the four made by a human hand. It governs brilliance — and, in a colored stone, how much color you see." }
    ]
  },

  cert:{
    eyebrow:"Certification",
    h:"The paper.",
    body:"The International Gemological Institute is one of the world's reference laboratories for laboratory-grown stones. Each of ours arrives with its own. It is worth knowing how to read one — not only ours, anyone's.",
    lines:[
      ["Report Number","The report's unique number. Use it to verify the stone at igi.org."],
      ["Laboratory Grown","This line must always appear. Without it, it is not a laboratory-grown report."],
      ["Growth Method","HPHT or CVD. How the stone was formed."],
      ["Shape and Cutting Style","The cut by its technical name — from round brilliant to kite, pentagon or Dutch marquise."],
      ["Color Grade","On a colored stone, the full fancy description: intensity, hue and tone. It is the line we read most closely."],
      ["Carat Weight","Exact weight, usually to two decimals."],
      ["Measurements","Millimeters. This is what actually tells you the face-up size."],
      ["Clarity Grade","FL through I3, accompanied by the clarity plot."],
      ["Cut · Polish · Symmetry","Cut, polish and symmetry quality. The cut grade applies only to rounds."],
      ["Fluorescence","Its reaction under ultraviolet light. None, Faint, Medium, Strong."],
      ["Laser Inscription","Many stones carry the number inscribed on the girdle. Read it with a 10× loupe."],
      ["Comments","Laboratory notes. Always worth reading."]
    ],
    habit:"At igi.org, under Report Check, enter the number and the report appears. It can be done during the live, before deciding. We consider it the healthiest habit in the trade."
  },

  record:{
    eyebrow:"The house",
    h:"Lucerna Miami.",
    body:"Lucerna is the skylight: the opening cut into a roof to let daylight in. We gave that name to a house selling the one object on earth that exists to do exactly the same thing. The stone is shown before it is sold, the paper is on screen before the bidding, and the unusual cut you have been looking for is probably already in the tray.",
    title:"Stone record", tag:"Example",
    rows:[
      ["Type","Laboratory-grown diamond"],
      ["Method","CVD"],
      ["Cut","Kite"],
      ["Weight","1.28 ct"],
      ["Color","Fancy Intense Pink"],
      ["Clarity","VS1"],
      ["Polish / Symmetry","Excellent / Excellent"],
      ["Measurements","9.14 × 6.02 × 3.41 mm"],
      ["Fluorescence","None"],
      ["Report","IGI · LG······"]
    ],
    note:"Sample record — this is how every stone is presented on the live."
  },

  days:{
    eyebrow:"The making",
    h:"Fifty days.",
    body:"People assume a grown diamond is quick. It is not. It is patient in a different place — and for most of those weeks, a person is watching it. A wafer of seed diamond sits in a methane-hydrogen plasma at 900–1,200 °C while carbon settles onto it one atomic layer at a time. Every few days the plate comes out, is re-polished by hand, and goes back in.",
    caption:"One three-carat fancy shape, stage by stage",
    colStage:"Stage", colDays:"Days",
    stages:[
      ["Seed preparation and reactor load","1"],
      ["Growth in the reactor","21–28"],
      ["Separation, mapping and marking","3"],
      ["Sawing, bruting and blocking","3"],
      ["Brillianteering and final polish","4–6"],
      ["IGI certification","15"]
    ],
    total:"From seed to certificate", totalV:"47–56",
    barTitle:"Where the days go — 49.5 days, typical",
    keyGrowth:"Growth", keyCutting:"Cutting", keyIgi:"IGI",
    hoursLabel:"Hours of skilled human attention",
    hoursBody:"Roughly 80 of them are a cutter's hands on a cast-iron scaife charged with diamond dust. Nothing leaves us uncertified — every stone goes to the IGI, and we do not chase that fifteen days down.",
    pull:"You are not paying for scarcity.", pull2:"You are paying for the days."
  },

  bespoke:{
    eyebrow:"Made to order",
    h:"Made to your measure.",
    body:"Send a sketch on the back of an envelope, a screenshot, or a photograph of something you saw in a window. We will build it. There is no catalog to choose from, because there is no catalog. Every Lucerna Miami piece is made once, for one person, by bench jewelers who came up through the trade.",
    offers:[
      ["Any design. Any stone.","Solitaire, three-stone, halo, bezel, toi-et-moi, or something nobody has made yet."],
      ["Solid gold.","Yellow, white or rose — solid all the way through. Never plated, never filled, never hollow."],
      ["Hand-finished at the bench.","Seats cut under magnification, galleries finished on the inside where only you will ever see them."],
      ["Your stone, or ours.","We will gladly set a diamond you already own, inherited or bought elsewhere."]
    ],
    specLabels:["Design","Metal","Finish","The stone"],
    chainTitle:"Six steps, start to finish",
    chainHint:"Select a step",
    chain:[
      { t:"Talk",   b:"A conversation, not a form. What the piece is for, who wears it, what they already own, what you would rather avoid. Ten minutes here saves three weeks later." },
      { t:"Sketch", b:"A hand drawing, sent to you the same week. Proportions, the stone's seat, the shoulder width. Change anything. Nothing is committed until you like the drawing." },
      { t:"CAD",    b:"The sketch becomes a precise 3D model, rendered from the angles you will actually see. This is where millimeters get decided — band width, gallery height, how high the stone sits." },
      { t:"Wax",    b:"The model is printed and cast. A physical object you could hold, if you were in the room. We photograph it against a hand for scale before anything is poured in gold." },
      { t:"Bench",  b:"A jeweler cuts the seats under magnification, sets the stone, and finishes the gallery on the inside — the part only the wearer ever sees. This is the slow part, and it should be." },
      { t:"Check",  b:"Final inspection under 10× magnification and two lighting conditions. More pieces go back to the bench here than most houses would tolerate. Then it is boxed, insured and sent." }
    ]
  },

  commission:{
    eyebrow:"Customization",
    h:"Tell us the piece.",
    body:"Send the details and a picture of what you want — a screenshot, a sketch, a photograph from a window. Our team reviews every request by hand and comes back with a quote.",
    fName:"Full name", fEmail:"Email", fPhone:"Phone or WhatsApp",
    fTikTok:"TikTok username", fTikTokHint:"If you bought from our live",
    fStone:"Which diamond", fStoneHint:"Cut, color, carat, or the IGI report number",
    fPiece:"What you would like made", fPieceOpts:["Ring","Pendant","Earrings","Bracelet","Not sure yet","Something else"],
    fDetails:"Tell us about the piece",
    fDetailsHint:"Metal color, finger size, occasion, budget range — anything that helps",
    fFile:"Attach a picture", fFileHint:"A screenshot, a sketch or a photo. Optional but it helps.",
    fFileChosen:"Attached",
    submit:"Send inquiry", sending:"Sending…",
    required:"Please fill in your name, email and what you would like made.",
    okTitle:"Thank you.",
    okBody:"Our team will reach out within the next 24 hours with a quote.",
    okNote:"A copy has been sent to info@lucernamiami.com.",
    mailNote:"Your email program has opened with everything filled in. Attach your picture and press send.",
    close:"Close",
    quoted:"Every made-to-order piece is quoted individually. Mounting prices depend on the design, the metal and the stone you are setting."
  },

  live:{
    eyebrow:"On camera",
    h:"The tray, on camera.",
    body:"We sell the loose stone. What you do with it afterwards — a solitaire, a pendant, an anniversary ring, a gift that looks like nobody else's — is the enjoyable part.",
    soon:"Live now, most nights",
    soonBody:"The tray goes on camera on TikTok. Stones are shown one at a time — certificate, measurements, color under two lights — and sold in the room.",
    cta:"Watch on TikTok", ctaSub:"@lucernadiamonds"
  },

  wornband:{
    eyebrow:"Worn",
    h:"After the tray.",
    body:"We sell the loose stone. What it becomes, and whose hand it ends up on, is the part we like watching.",
    cta:"See them worn"
  },

  worn:{
    eyebrow:"Worn",
    h:"On the hand.",
    body:"Every piece here started as a loose stone on a velvet tray, picked by somebody who knew exactly which one they wanted. Then our bench set it.",
    note:"Made to order. No two the same. Tell us what you have in mind and we will draw it first.",
    cta:"Design your piece"
  },

  pages:{
    eyebrow:"The house",
    h:"Inside the house.",
    items:[
      { k:"book",    t:"The Book",      s:"Thirty-nine cuts",           b:"Kite, Dutch marquise, old mine, star. Filter by color and by shape.",            img:"trade-01-tweezers", href:"#selection" },
      { k:"vault",   t:"The Vault",     s:"What is in the tray",        b:"Stones with their carat, their color and their IGI number.",                     img:"trade-04-desk",     href:"#vault" },
      { k:"diamond", t:"The Diamond",   s:"Same carbon, shorter story", b:"Fifty days from seed to certificate, explained without the sales pitch.",         img:"stone-hero",        href:"#stone" },
      { k:"order",   t:"Made to Order", s:"Build the piece",            b:"Six steps from a conversation to a finished ring.",                              img:"ring-05-backlit",   href:"#bespoke" },
      { k:"journal", t:"The Journal",   s:"Every commission",           b:"The stone, what was asked for, the metal, and what left the bench.",              img:"trade-04-desk",     href:"#journal" },
      { k:"house",   t:"The House",     s:"Where the shop buys",        b:"A tray, a loupe, and a table in Miami.",                                         img:"trade-05-handover", href:"#ethics" }
    ]
  },

  vault:{
    eyebrow:"The vault",
    h:"What is in today.",
    soon:"Sold live for now",
    body:"The online vault is being built. Until it opens, everything we have is shown on TikTok — every stone with its IGI report number, its measurements and its color under two lights. If you are after a particular cut or color, tell us and we will look for it.",
    cta:"See what is in the tray", ctaSub:"@lucernadiamonds",
    alt:"Ask for a specific stone"
  },

  ethics:{
    eyebrow:"Why it matters",
    h:"Where it comes from.",
    body:"Every mined carat carries a history you cannot see. A grown diamond carries one you can read — no pit opened, no riverbed diverted, no ore body displaced, no tailings dam left for the next century to manage.",
    items:[
      ["No conflict. Ever.","Grown in a sealed reactor under one roof. No mine, no militia, no chain of custody to take on faith."],
      ["No ground broken.","No pit, no overburden, no tailings, no rehabilitation debt left to a community."],
      ["Water stays where it is.","No river diverted, no silt, no processing slurry to settle out afterwards."],
      ["A footprint that can improve.","Energy is the only real input, and energy can be made cleanly. A mine cannot be un-dug."]
    ],
  },

  films:{
    hero:"One stone, turned slowly, under one light.",
    girdle:"Every claim about a diamond is a measurement. Here is the stone the measurements describe.",
    ring:"The stone is chosen first. Everything after it is built to fit.",
    tray:"What is in the tray this week, and what is already spoken for.",
    wax:"It begins in wax, cut by hand, sized to your stone and no other.",
    bench:"A seat is cut for the girdle. A tenth of a millimetre decides whether it holds.",
    setting:"The stone goes down once. There is no second attempt that does not show.",
    final:"Then it is polished, and it is yours.",
  },
  forms:{
    linkHint:"Paste a link \u2014 Drive, Dropbox, iCloud",
    posted:"Thank you \u2014 your message is with the house. We answer every one within 24 hours.",
  },
  journalEntries:[],
  faq:{
    eyebrow:"Questions",
    h:"Questions.",
    items:[
      ["Is a laboratory-grown diamond a real diamond?",
       "Yes. Same carbon lattice, same 10 on the Mohs scale, same brilliance and fire. It is not moissanite and not cubic zirconia — those are different materials that imitate diamond. A laboratory diamond IS diamond; the only difference is where it crystallized."],
      ["Will anyone be able to tell?",
       "Not by eye, and not with a loupe. A gemologist needs specialist equipment. Your IGI report states plainly that the stone is laboratory-grown, and many stones carry the report number inscribed on the girdle."],
      ["What does an IGI certificate actually guarantee?",
       "It records what the laboratory measured: growth method, shape, carat, color grade, clarity, measurements, polish, symmetry and fluorescence. You can verify any report yourself at igi.org under Report Check, using the report number — during the live, before you decide."],
      ["Do you sell finished jewelry?",
       "We sell the loose stone. Mountings are made to order at the bench — ring, pendant, earrings or bracelet — and we will gladly set a diamond you already own. Start with the made-to-order form on this page."],
      ["How much does a mounting cost?",
       "The configurator on this page gives you the real setting price instantly, from the same chart we quote from on the phone. A design that falls outside the chart is quoted individually, and the team replies within 24 hours."],
      ["How long does a bespoke piece take?",
       "Talk, sketch, CAD, wax, bench, check. Typically three to five weeks from approved CAD, depending on the design and whether the stone is in the tray or still growing."],
      ["Is a laboratory diamond a good investment?",
       "No, and we would rather say so. Resale value is modest, and prices in the category have fallen for years. Buy it because it is beautiful and because it is the color and cut you wanted — not as an asset."],
      ["What happens if the stone arrives damaged or not as described?",
       "It is put right without discussion. What appears on screen is what arrives in the box; that is the whole point of showing the certificate first."],
      ["Do you ship outside the United States?",
       "Yes, insured and tracked. Duties and import taxes are the buyer's responsibility and vary by country — write to us before bidding and we will tell you what to expect."],
      ["Can I request a cut you do not have?",
       "Often, yes. Availability changes weekly and we can commission a shape. Tell us the cut, the color and the carat you have in mind and we will tell you honestly whether it is realistic."],
      ["Do you speak Spanish?",
       "Sí. The live, the website and the paperwork are all available in Spanish — it is the house language."],
      ["How do I reach a real person?",
       "Ask Lucía for a representative and she will take your details, or write to info@lucernamiami.com. Our team replies within 24 hours, every day."]
    ]
  },

  contact:{
    eyebrow:"Contact",
    h:"Let us talk.",
    email:"Email", tiktok:"TikTok", hours:"Hours", hoursV:"Every day",
    replies:"Replies", repliesV:"Within 24 hours",
    cityLine:"Lucerna Miami · Miami, Florida",
    blurb:"Laboratory-grown diamonds in rare shapes and rare colors. Every stone IGI certified, every mounting made to order, every piece made once.",
    formT:"Or write to us here",
    fName:"Name", fEmail:"Email", fPhone:"Phone or WhatsApp (optional)",
    fTopic:"What it's about", fTopicOpts:["A specific stone","Alerts for the next live","Setting a stone I already own","A custom mounting","Wholesale","Something else"],
    fMsg:"Your message", send:"Send", sending:"Sending…",
    ok:"Received. We'll reply within 24 hours.",
    err:"We need a name and a valid email."
  },

  legal:{
    terms:"Terms & Conditions", privacy:"Privacy Policy", shipping:"Shipping & Returns",
    back:"Back to the house", updated:"Last updated",
    disclaimer:"All diamonds sold by Lucerna Miami are laboratory-grown and are accompanied by an IGI report. Laboratory-grown diamonds are chemically, physically and optically identical to mined diamonds. Prices are quoted in US dollars; stones and mountings are quoted separately and individually. Screen color varies by device — the IGI report is the definitive description of any stone. Laboratory-grown diamonds are not sold as investments and resale value is modest. Availability changes weekly."
  },

  footer:{ rights:"All rights reserved", line:"Lab-grown · IGI certified · Made to order",
           tagline:"Under any light." },

  bot:{
    title:"Lucía", role:"House concierge",
    hello:"Good evening — I am Lucía, from the house.\n\nAsk me about a shape, a color, what fifty days in the reactor actually buys you, or what it would cost to set a stone you already own. If you would rather speak to someone on the team, just say so.",
    chips:["What is a Dutch marquise?","Lab-grown or mined?","Set a stone I already own","Talk to a representative"],
    ph:"Ask about a stone, a shape, a price…",
    offline:"Write to info@lucernamiami.com",
    noReach:"I cannot reach the house line from this view. Write to info@lucernamiami.com and the team will answer within 24 hours.",
    notGranted:"I would need your permission to answer from here. info@lucernamiami.com reaches the bench directly.",
    rateLimited:"One moment — too many questions at once. Try me again shortly.",
    generic:"Something went wrong on my side. info@lucernamiami.com reaches the bench directly.",
    connecting:"Connecting…",
    leadOk:"Thank you — I have passed your details to the team. Someone will reach out within the next 24 hours.",
    offerForm:"That one I would rather not answer from memory. Send it to the house and you will have a proper answer within 24 hours.",
    openForm:"Open the made-to-order form"
  },

  seo:{
    title:"Lucerna Miami — IGI-Certified Lab-Grown Diamonds",
    desc:"Thirty-nine diamond cuts in nine fancy colors, every stone IGI certified and laser inscribed. Kite, pentagon, Dutch marquise and oval step, made to order in Miami."
  }
};
